import { yupResolver } from '@hookform/resolvers/yup';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import type React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { AudienceForm } from '../../../AudienceForm/types';
import { getBaseAudienceFormSchema } from '../../../AudienceForm/utils/validationSchema';
import { useAudienceFetch } from '../../hooks/useAudienceFetch';

type ProviderProps = {
  audience: AudienceForm;
  children: React.ReactNode;
};

const Provider = ({ audience, children }: ProviderProps) => {
  const { t } = useTranslation();

  const formMethods = useForm<AudienceForm>({
    defaultValues: {
      ...audience,
    },
    mode: 'all',
    resolver: yupResolver(getBaseAudienceFormSchema(t)),
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export function AudienceFormProvider({ children }) {
  const { audience, loading } = useAudienceFetch();

  return loading ? <Loader /> : <Provider audience={audience}>{children}</Provider>;
}
